import request from "@/utils/request";

export function getRouter(params) {
  return request({
    url: "/ResourceManagement/GetSystemMenuTree",
    method: "get",
    params
  });
}
export function updateMenu(data) {
  return request({
    url: "/ResourceManagement/UpdateMenu",
    method: "post",
    data
  });
}
export function addMenu(data) {
  return request({
    url: "/ResourceManagement/AddMenu",
    method: "post",
    data
  });
}
export function deleteMenu(data) {
  return request({
    url: "/ResourceManagement/DeleteMenu",
    method: "delete",
    data
  });
}
